import { motion } from "framer-motion";
import { Crown, Megaphone, Headset, Truck, TrendingUp, GraduationCap } from "lucide-react";

const BENEFITS = [
  { icon: Crown, title: "Monopoly Rights", body: "Exclusive distribution rights for your district. One partner per territory — zero internal competition." },
  { icon: Megaphone, title: "Marketing Support", body: "Free visual aids, product cards, digital catalogue, MR bags and promotional inputs for every partner." },
  { icon: Headset, title: "Dedicated Manager", body: "A personal relationship manager to support orders, queries and growth planning at every stage." },
  { icon: Truck, title: "Fast Dispatch", body: "In-house manufacturing means quick turnaround and reliable, on-time delivery across India." },
  { icon: TrendingUp, title: "High Margins", body: "Transparent, direct-from-plant PCD pricing with strong margins and no hidden middlemen." },
  { icon: GraduationCap, title: "Training & Guidance", body: "Product knowledge, positioning and sales training to help you win doctors and retailers." },
];

export default function WhyChoose() {
  return (
    <section id="why" className="bg-[#f9f8f5] py-20 md:py-28" data-testid="why-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <div className="eyebrow text-[#d46a1d]">Why Partner With Us</div>
          <h2 className="mt-3 font-serif text-4xl tracking-tight text-[#202124] md:text-5xl">
            Everything you need to build a thriving business
          </h2>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {BENEFITS.map((b, i) => {
            const Icon = b.icon;
            return (
              <motion.div key={b.title}
                initial={{ opacity: 0, y: 22 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                className="rounded-2xl border border-[#e7e0d6] bg-white p-7 transition-transform hover:-translate-y-1 card-shadow"
                data-testid={`benefit-${i}`}>
                <div className="grid h-12 w-12 place-items-center rounded-xl bg-[#eef3ee] text-[#1f5d3a]">
                  <Icon size={22} />
                </div>
                <h3 className="mt-5 font-serif text-2xl text-[#202124]">{b.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#6b6a65]">{b.body}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
